import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import { Provider } from "react-redux";
// import { store } from "./services/store";
import "./styles/index.css";
import { routes } from "./routes";
// import { AuthProvider } from "react-oidc-context";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://1089be2202462a1db3c83383d25f96f0@o4508521366290432.ingest.de.sentry.io/4508521370746960",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const router = createBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_R8cdRrNoA",
  client_id: "738ejmugo6k058lc890uqm2jbg",
  redirect_uri: "http://localhost:5173", // "https://joachim.website",
  response_type: "code",
  scope: "email openid",
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* <AuthProvider {...cognitoAuthConfig}> */}
    {/* <Provider store={store}> */}
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
    {/* </Provider> */}
    {/* </AuthProvider> */}
  </StrictMode>
);
